<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->

<epg-image-slider
  [images]="sliderItems"
  (imageClick)="(imageClick)"
  (lightboxClose)="(lightboxClose)"
  [displayBorder]="displayBorder"
  [imageHeightInPx]="imageSize?.height"
  [stretchToContainer]="stretchToContainer"
></epg-image-slider>
